// Token 工具函数 - 使用 localStorage 存储 token，所有标签页共享
const TOKEN_STORAGE_KEY = 'app_access_token';

// 获取 token
export function getToken() {
  const tokenStr = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (tokenStr) {
    return JSON.parse(tokenStr);
  }
  return null;
}

// 设置 token
export function setToken(token) {
  const tokenData = {
    access_token: token.access_token,
    token_type: token.token_type || 'Bearer',
    expires_in: token.expires_in || 365 * 24 * 3600, // 默认 1 年
    token_created_at: token.token_created_at || Date.now(),
  };
  localStorage.setItem(TOKEN_STORAGE_KEY, JSON.stringify(tokenData));
}

// 清除 token
export function clearToken() {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
}
